<template>
  <div class="logo">
    <router-link :to="{name:'dashboard'}">
      <img src="/logo.png">
      <h1 v-if="showTitle">{{ title }}</h1>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  components: {
  },
  props: {
    title: {
      type: String,
      default: '米亚云进销存系统',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
